import type { GenerationJob } from './services'
import type { GeneratedAudioRecord } from './repository'

const REFINED_BELTOUT_MODEL = 'BeltOut@f71295e33cc9c0092083089ed0f9c1a532e77e6b'
const REFINED_BELTOUT_PIPELINE = 'beltout-s20-w085-protectedplan-pcm32float-xfade20ms-wholegain99-v1'

export function generationMethodLabel(job: GenerationJob): string | null {
  if (job.provider !== 'voice_conversion_http' && job.provider !== 'voice_conversion_preview_http') return null
  if (job.modelRevision === REFINED_BELTOUT_MODEL && job.pipelineVersion === REFINED_BELTOUT_PIPELINE) return 'BeltOut 정교화 방식'
  if (job.modelRevision?.startsWith('BeltOut@')) return 'BeltOut 변환'
  if (job.modelRevision) return '이전 변환 방식'
  return '제작 당시 방식 확인 중'
}

/** These fields travel with an offline audio file; a missing value is not evidence of a passed check. */
export function savedAudioProvenance(record: GeneratedAudioRecord): { label: string | null; warning: string | null } {
  if (record.experimentalPreview === true) {
    return {
      label: '개발용 · 품질 미검증',
      warning: '개발용 실험 변환 음원이에요. 내용 정확도와 목소리 품질을 검증하지 않았으니 아이에게 들려주기 전에 직접 확인해 주세요.',
    }
  }
  if (record.qualityStatus === 'unverified') {
    return {
      label: '품질 미검증',
      warning: '이 음원은 내용 정확도와 목소리 품질을 검증하지 않았어요. 아이에게 들려주기 전에 직접 확인해 주세요.',
    }
  }
  if ((record.qualityWarningCount ?? 0) > 0) {
    return {
      label: '자동 검사 경고',
      warning: `자동 음원 검사에서 확인이 필요한 구간이 ${record.qualityWarningCount}곳 있어요. 직접 들어 확인해 주세요.`,
    }
  }
  if (record.experimentalPreview !== false || !record.modelRevision || !record.pipelineVersion) {
    return {
      label: '제작 정보 확인 불가',
      warning: '저장 당시의 제작 방식이나 품질 확인 정보가 없어 검증 여부를 확인할 수 없어요.',
    }
  }
  return { label: null, warning: null }
}
